var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.error)?_c('div',{staticClass:"form-item"},[_c('div',{staticClass:"notice active notice_red restore-notice"},[_c('div',{staticClass:"content_subtitle content_red content_700 mb-1"},[_vm._v(_vm._s(_vm.msg.title))]),_c('div',{staticClass:"content_18",domProps:{"innerHTML":_vm._s(_vm.msg.text)}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }